<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
<!--                <div>-->
<!--                    <el-select v-model="query.hospitalId" placeholder="请选择" size="small">-->
<!--                        <el-option-->
<!--                                v-for="item in hospitalList"-->
<!--                                :key="item.hospitalId"-->
<!--                                :label="item.hospitalName"-->
<!--                                :value="item.hospitalId">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </div>-->
                <div>
                    <el-button type="primary" @click="dialogAddVisible = true" style="width: 96px">新增科室</el-button>
                </div>
            </div>
            <div>
                <el-table
                        :data="tableData"
                        v-loading="loading"
                        :header-cell-style="{'padding-left': '15%'}"
                        :cell-style="{'padding-left': '15%'}">
                    <el-table-column prop="departmentName" label="科室名称"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="openEdit(scope.row)">编辑</el-button>
<!--                            <el-button type="text" @click="openSet(scope.row)">配置</el-button>-->
                            <el-button type="text" class="delete-button" @click="deleteDepartment(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增科室" :visible.sync="dialogAddVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelAdd">
            <el-form :model="departmentAdd" :rules="rules" ref="add" size="small">
                <el-form-item label="科室名称" label-width="100px" prop="departmentName">
                    <el-input v-model="departmentAdd.departmentName" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px;">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑科室" :visible.sync="dialogEditVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelEdit">
            <el-form :model="departmentEdit" :rules="rules" ref="edit" size="small">
                <el-form-item label="科室名称" label-width="100px" prop="departmentName">
                    <el-input v-model="departmentEdit.departmentName" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEdit" style="width: 76px;">取消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px;">确定</el-button>
            </div>
        </el-dialog>
<!--        <el-dialog :title="department" :visible.sync="departmentVisible" width="700px" :close-on-click-modal="false">-->
<!--            <div style="text-align: center">-->
<!--                <el-transfer-->
<!--                        style="text-align: left; display: inline-block"-->
<!--                        v-if="items.length !== 0"-->
<!--                        v-model="overDoctor"-->
<!--                        filterable-->
<!--                        filter-placeholder="搜索员工姓名"-->
<!--                        :titles="['员工', '已配置']"-->
<!--                        :format="{-->
<!--                            noChecked: '${total}',-->
<!--                            hasChecked: '${checked}/${total}'-->
<!--                         }"-->
<!--                        :props="{-->
<!--                            key: 'userId',-->
<!--                            label: 'realName',-->
<!--                        }"-->
<!--                        :data="items">-->
<!--                    <span slot-scope="{ option }">{{ option.realName }}</span>-->
<!--                </el-transfer>-->
<!--            </div>-->
<!--            <div slot="footer" class="dialog-footer charge">-->
<!--                <el-button @click="departmentVisible = false" style="width: 76px">取消</el-button>-->
<!--                <el-button type="primary" @click="saveSet" style="width: 76px">确定</el-button>-->
<!--            </div>-->
<!--        </el-dialog>-->
    </div>
</template>

<script>
    export default {
        data() {
            return {
                authorization:localStorage.getItem('authorization'),
                // query: {
                //     hospitalId: ''
                // },
                hospitalList: [],
                // 表格信息
                loading: true,
                tableData: [],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                pages: 1,
                // 弹窗开关
                dialogAddVisible: false,
                dialogEditVisible: false,
                // 新增科室弹窗数据
                departmentAdd:{
                    departmentName: '',
                },
                rules: {
                    departmentName: [{required: true, message: '请输入科室名称', trigger: 'blur'},],
                },
                // 编辑科室弹窗数据
                departmentEdit:{
                    departmentName: '',
                },
                departmentVisible: false,
                department: '',
                items: [],
                overDoctor: [],
            }
        },
        methods: {
            // 获取科室列表
            getData() {
                this.loading = true
                let params = {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                }
                this.axios.post('/api-b/10035/100112',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list !== null) {
                            this.tableData = res.data.data.list
                        } else {
                            this.$message.info('暂无科室数据')
                            this.tableData = []
                        }
                        this.total = res.data.data.total
                    } else {
                        this.tableData = []
                        this.$message.error(res.data.message)
                        this.total = 0
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                    this.tableData = []
                    this.total = 0
                })
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.getData()
            },

            // 取消新增
            cancelAdd() {
                this.dialogAddVisible = false
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                })
            },
            // 确定添加科室
            confirmAdd() {
                let params = {
                    departmentName: this.departmentAdd.departmentName
                }
                this.axios.post('/api-b/10035/100113',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.dialogAddVisible = false
                        this.getData()
                        this.$nextTick(() => {
                            this.$refs.add.resetFields()
                        })
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 打开编辑科室弹窗
            openEdit(data) {
                this.axios.get('/api-b/10035/100116/' + data.departmentId,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.departmentEdit = res.data.data
                        this.dialogEditVisible = true
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 取消修改
            cancelEdit() {
                this.dialogEditVisible = false
                this.$nextTick(() => {
                    this.$refs.edit.clearValidate()
                })
            },
            // 确认编辑科室
            confirmEdit() {
                let params = {
                    departmentName: this.departmentEdit.departmentName,
                    departmentId: this.departmentEdit.departmentId
                }
                this.axios.put('/api-b/10035/100115',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.dialogEditVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // // 获取已配置员工
            // getOverUser(departmentId) {
            //     return new Promise((resolve, reject) => {
            //         this.axios.get('/api-b/10035/100140/' + departmentId,{
            //             headers:{
            //                 Authorization: this.authorization
            //             }
            //         }).then(res => {
            //             this.overDoctor = []
            //             if (res.data.code === 10000) {
            //                 if (res.data.data.length !== 0) {
            //                     for (let i=0;i<res.data.data.length; i++) {
            //                         this.overDoctor.push(res.data.data[i].doctorId)
            //                     }
            //                 }
            //                 resolve()
            //             } else {
            //                 reject()
            //             }
            //         }).catch(() => {
            //             reject()
            //         })
            //     })
            // },
            // // 获取员工列表
            // getUserList() {
            //     return new Promise((resolve, reject) => {
            //         let params = {
            //             pageNum: 1,
            //             pageSize: 999,
            //         }
            //         this.axios.post('/api-u/10024/100121',params,{
            //             headers:{
            //                 Authorization: this.authorization
            //             }
            //         }).then(res => {
            //             if (res.data.code === 10000) {
            //                 if (res.data.data.list === null) {
            //                     this.$message.info('暂无员工数据')
            //                     reject()
            //                 } else {
            //                     this.items = res.data.data.list
            //                     resolve()
            //                 }
            //             } else {
            //                 this.$message.error(res.data.message)
            //                 this.items = []
            //                 reject()
            //             }
            //         }).catch(() => {
            //             this.items = []
            //             reject()
            //         })
            //     })
            // },
            // // 打开配置弹窗
            // openSet(data) {
            //     this.departmentEdit = data
            //     Promise.all([this.getOverUser(data.departmentId),this.getUserList()]).then(() => {
            //         this.department = data.departmentName
            //         this.departmentVisible = true
            //     })
            // },
            // // 保存配置结果
            // saveSet() {
            //     let params = []
            //     for (let i=0;i<this.overDoctor.length; i++){
            //         let doctor = {
            //             doctorId: this.overDoctor[i]
            //         }
            //         params.push(doctor)
            //     }
            //     this.axios.post('api-b/10035/100139/' + this.departmentEdit.departmentId,params,{
            //         headers:{
            //             Authorization: this.authorization
            //         }
            //     }).then(res => {
            //         if (res.data.code === 10000) {
            //             this.$message.success(res.data.message)
            //             this.departmentVisible = false
            //             this.getData()
            //         } else {
            //             this.$message.error(res.data.message)
            //         }
            //     })
            // },
            // 删除科室
            deleteDepartment(data) {
                const h = this.$createElement;
                this.$msgbox({
                    message: h('div',{class:'message-box'}, [
                        h('div', { class: 'message-title-box'}, [
                            h('i', { class:'el-icon-warning message-box-icon' }, ''),
                            h('span', { class:'message-box-title'}, '确认删除该科室吗？'),
                        ]),
                    ]),
                    showConfirmButton:true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    this.axios.delete('/api-b/10035/100114/' + data.departmentId, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message);
                            this.getData()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }).catch(() => {})
            }
        },
        watch: {
            query: {
                handler() {
                    this.pageNum = 1
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.getData()
                    }, 300);
                },
                deep: true
            }
        },
        created() {
            this.getData()
            // this.getHospital()
        }
    }

</script>
<style>
    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }
    .el-button--primary:hover {
        background:rgba(120,180,255,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-button--primary:focus {
        background:rgba(57,129,221,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
</style>